import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import WhatWeDo from './components/WhatWeDo';
import ClaimsTypes from './components/ClaimsTypes';
import Process from './components/Process';
import About from './components/About';
import Statistics from './components/Statistics';
import Careers from './components/Careers';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation isScrolled={isScrolled} />
      <Hero />
      <TrustStrip />
      <WhatWeDo />
      <ClaimsTypes />
      <Process />
      <About />
      <Statistics />
      <Careers />
      <CTASection />
      <Footer />
    </div>
  );
}